import { useQuery } from '@tanstack/react-query'

import type { GetActiveLoadingSlideResponse } from '../../types/loading-slide.js'

import { apiClient } from '../../lib/client.js'
import { loadingSlideKeys } from './keys.js'

export interface UseGetActiveLoadingSlideQueryParams {
  iataCode?: string
  originIataCode?: string
}

export const useGetActiveLoadingSlideQuery = (params?: UseGetActiveLoadingSlideQueryParams) => {
  return useQuery({
    queryFn: async () => {
      const response = await apiClient.client.get<GetActiveLoadingSlideResponse | null>(
        '/loading-slide/active',
        { params: { iataCode: params?.iataCode, originIataCode: params?.originIataCode } }
      )
      return response.data
    },
    queryKey: loadingSlideKeys.active(params),
  })
}
